import { Attachment } from '@smg-real-estate/hg-rets-schema';

/** Possible listing image types: https://github.com/smg-real-estate/chat-relay/blob/main/docker/code/schemas/listing_description.py */
export enum DescribeImageType {
  BATHROOM = 'Bathroom',
  HOUSE = 'House',
  KITCHEN = 'Kitchen',
  LIVING_ROOM = 'Living Room',
  BEDROOM = 'Bedroom',
  FLOOR_PLAN = 'Floor Plan',
  BUILDING = 'Building',
  GARDEN_OUTDOOR = 'Garden / Outdoor Area',
  CORRIDOR_HALLWAY = 'Corridor / Hallway',
  BALCONY_TERRACE = 'Balcony / Terrace',
  OTHER = 'Other',
  UNFURNISHED_ROOM = 'Unfurnished Room',
  FURNISHED_ROOM = 'Furnished Room',
}

export const VALID_ROOM_TYPES_FOR_RESTAGE = [
  DescribeImageType.BATHROOM,
  DescribeImageType.KITCHEN,
  DescribeImageType.LIVING_ROOM,
  DescribeImageType.BEDROOM,
  DescribeImageType.UNFURNISHED_ROOM,
  DescribeImageType.FURNISHED_ROOM,
] as string[];

export function isValidRoomTypeForRestage(imageAttachment: Attachment): boolean {
  const classification = imageAttachment.attachmentAnnotation?.image?.classification;

  if (!classification) {
    return false;
  }

  return VALID_ROOM_TYPES_FOR_RESTAGE.includes(classification);
}
